import { createSvgIcon } from '@automata/mui-theme';
export const CountIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23 19H19V77H23V19ZM16 16V80H26V16H16Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M77 19H73V77H77V19ZM70 16V80H80V16H70Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36 35C37.1046 35 38 34.1046 38 33C38 31.8954 37.1046 31 36 31C34.8954 31 34 31.8954 34 33C34 34.1046 34.8954 35 36 35ZM36 37C38.2091 37 40 35.2091 40 33C40 30.7909 38.2091 29 36 29C33.7909 29 32 30.7909 32 33C32 35.2091 33.7909 37 36 37Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36 50C37.1046 50 38 49.1046 38 48C38 46.8954 37.1046 46 36 46C34.8954 46 34 46.8954 34 48C34 49.1046 34.8954 50 36 50ZM36 52C38.2091 52 40 50.2091 40 48C40 45.7909 38.2091 44 36 44C33.7909 44 32 45.7909 32 48C32 50.2091 33.7909 52 36 52Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48 35C49.1046 35 50 34.1046 50 33C50 31.8954 49.1046 31 48 31C46.8954 31 46 31.8954 46 33C46 34.1046 46.8954 35 48 35ZM48 37C50.2091 37 52 35.2091 52 33C52 30.7909 50.2091 29 48 29C45.7909 29 44 30.7909 44 33C44 35.2091 45.7909 37 48 37Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48 50C49.1046 50 50 49.1046 50 48C50 46.8954 49.1046 46 48 46C46.8954 46 46 46.8954 46 48C46 49.1046 46.8954 50 48 50ZM48 52C50.2091 52 52 50.2091 52 48C52 45.7909 50.2091 44 48 44C45.7909 44 44 45.7909 44 48C44 50.2091 45.7909 52 48 52Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M60 50C61.1046 50 62 49.1046 62 48C62 46.8954 61.1046 46 60 46C58.8954 46 58 46.8954 58 48C58 49.1046 58.8954 50 60 50ZM60 52C62.2091 52 64 50.2091 64 48C64 45.7909 62.2091 44 60 44C57.7909 44 56 45.7909 56 48C56 50.2091 57.7909 52 60 52Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M48 66C49.1046 66 50 65.1046 50 64C50 62.8954 49.1046 62 48 62C46.8954 62 46 62.8954 46 64C46 65.1046 46.8954 66 48 66ZM48 68C50.2091 68 52 66.2091 52 64C52 61.7909 50.2091 60 48 60C45.7909 60 44 61.7909 44 64C44 66.2091 45.7909 68 48 68Z"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M33 34H25V32H33V34Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M46 34H38V32H46V34Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M70 34H51V32H70V34Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M33 49H25V47H33V49Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M46 49H38V47H46V49Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M58 49H50V47H58V49Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M71 49H63V47H71V49Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M45 65H25V63H45V65Z" />
    <path fillRule="evenodd" clipRule="evenodd" d="M71 65H51V63H71V65Z" />
  </svg>,
  'CountIcon'
);
